import ErrorBoundary from '@components/ErrorBoundary';
import PageContainer from '@components/PageContainer';
import Spinner from '@components/spinner/Spinner';
import { Suspense } from 'react';
import { Outlet } from 'react-router-dom';

export default function ChatWithDataLayout() {
  return (
    <PageContainer title={'Interview | Chat with Data'}>
      <Suspense fallback={<Spinner />}>
        <ErrorBoundary>
          <Outlet />
        </ErrorBoundary>
      </Suspense>
    </PageContainer>
  );
}
